import { render, staticRenderFns } from "./BCKeyAssignmentMenu.vue?vue&type=template&id=f0a27bb2&scoped=true"
import script from "./BCKeyAssignmentMenu.vue?vue&type=script&lang=js"
export * from "./BCKeyAssignmentMenu.vue?vue&type=script&lang=js"
import style0 from "./BCKeyAssignmentMenu.vue?vue&type=style&index=0&id=f0a27bb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a27bb2",
  null
  
)

export default component.exports